import HeroSection from '../components/home/HeroSection'
import ValuePropositionBanner from '../components/home/ValuePropositionBanner'
import VideoSection from '../components/home/VideoSection'
import ReactiveSection from '../components/home/ReactiveSection'
import StorySection from '../components/home/StorySection'
import LandSection from '../components/home/LandSection'
import AirSection from '../components/home/AirSection'
import SpaceSection from '../components/home/SpaceSection'
import CycleSection from '../components/home/CycleSection'
import MobileSection from '../components/home/MobileSection'
import MLSection from '../components/home/MLSection'
import StatsSection from '../components/home/StatsSection'
import CTASection from '../components/home/CTASection'

export default function Home() {
  return (
    <>
      <HeroSection />
      <ValuePropositionBanner />
      <VideoSection />
      <ReactiveSection />
      <MLSection />
      <LandSection />
      <AirSection />
      <SpaceSection />
      <CycleSection />
      <StorySection />
      <MobileSection />
      <StatsSection />
      <CTASection />
    </>
  )
}
